export default {
    layout: {
         zh: '简体中文',
        zhTw: '繁體中文',
        en: 'English',
        kr: '한국어',
        jp: '日本語',
        copyAddress: 'Copy address',
        switchWallet: 'Switch wallet',
        disconnect: 'Disconnect',
        copied: 'Copied',
        failed:'failed',
        success:'success',
    },
    node: {
        progress: 'In progress',
        executionSuccessful: 'Successful',
        at: 'on',
        view: 'View',
    },
    menu: {
        home: 'Home',
        exchange: 'Swap',
        mining: 'Mining',
        assets: 'Assets',
        earnings: 'Earnings',
        me: 'Me',
        notice: 'Notice',
    },
    exchange: {
        title: 'Swap',
        send: 'Send',
        receive: 'Receive',
        obtain: 'Get',
        consume: 'Spend',
        balance: 'Balance',
        max: 'Max',
        currentPrice: 'Price',
        submit: 'Swap',
        records: 'History',
        price: 'Price',
        success: 'Success',
        fail: 'Failed',
    },
    home: {
        brand: 'OnOx',
        slogan: 'Connect globally, empower the future',
        sloganDesc: 'Decentralized · Open · Efficient',
        yield: 'APY',
        notice: 'Notice 1, ABC mining is live',
        todayOutput: 'Today pool output',
        networkHashrate: 'Network hashrate',
        price: 'Token price',
        burned: 'Total burned',

        aboutTitle: '$DOL Deflation Engine',
        aboutDesc: 'Six burn channels fuel $DOL value growth',
        featureHashrate: 'Burn $DOL, Earn Hashrate',
        featureHashrateDesc: 'Unlimited referral & team hashrate boosts',
        featureDaily: 'Daily Settlement',
        featureDailyDesc: 'Rewards based on valid hashrate, fully traceable',
        featureSecurity: 'Rising Hashrate',
        featureSecurityDesc: 'Hashrate per new deposit increases daily',
        
        bindTitle: 'Bind invite address',
        bindConfirm: 'Confirm',
        bindPlaceholder: '0x000000000000000000000000000000',
        h11:'ONOX CHARTER',
        h12:'DOLPHFI ECOSYSTEM FIRST DAPP',
        h21:'ONOX CHARTER',
        h22:'IGNITE THE FUTURE',
        h31:'OnOx',
        h32:'IGNITE THE BULL RUN'
    },
    mining: {
        title: 'Burn mining',
        subtitle: 'Activate hashrate and share ecosystem rewards',
        totalT: 'Total (T)',
        shareT: 'Shared',
        teamT: 'Team',
        burnT: 'Burned',
        validBurnT: 'Valid burned',
        renew: 'Renew',
        amountPlaceholder: 'Enter burn hashrate',
        token: 'Burn token',
        rate: 'Live rate',
        balance: 'Wallet balance',
        submit: 'Join burn mining',
        hint: 'You will get',
        burnLog: 'Burn logs',
        shareLog: 'Shared',
        renewLog: 'Renewals',
        success: 'Success',
        fail: 'Failed',
        qty: 'Amount',
        hashrateT: 'Hashrate (T)',
        renewHashrate: 'Renew hashrate',
        renewFee: 'Renew fee',
        renewDate: 'Hashrate period',
        renewConvert: 'Converted',
        renewNote: 'Note',
        renewNoteText: 'Please renew before 2026.10.1, or mining rewards will stop.',
        renewConfirm: 'Confirm renew',
        ext1:'Reward Hashrate',
        ext2:'Mining Earnings',
        ext3:'Renewal Amount',
        rechargeTip: 'Participating for the first time? Please top up with DOL or USDT first.',
        goRecharge: 'Go to Top Up',
        renewdo: 'Renewed',
    },
    earnings: {
        balance: 'Balance',
        recharge: 'Deposit',
        withdraw: 'Withdraw',
        totalWithdraw: 'Total withdrawn',
        totalIncome: 'Total income',
        mineIncome: 'Mining income',
        referral: 'Referral',
        incomeLog: 'Income',
        rechargeLog: 'Deposits',
        withdrawLog: 'Withdrawals',
        qty: 'Amount',
        success: 'Success',
        pending: 'Pending',
        fail: 'Failed',
        1: 'Success',
        0: 'Pending',
        2: 'Failed',
        rechargeQty: 'Deposit amount',
        withdrawQty: 'Withdraw amount',
        receiveQty: 'Received',
        rechargeTitle: 'Deposit',
        withdrawTitle: 'Withdraw',
        rechargeMin: 'Min 10',
        minAmount: 'Min 100',
        toAccount: 'You receive',
        fee: 'Fee',
        rechargeAddress: 'Deposit address',
        address: 'Address',
        confirmRecharge: 'Confirm',
        confirmWithdraw: 'Confirm',
        recharpcho:'please enter amount',
        l1:'Mining Earnings',
        l2:'Direct Referral Rewards',
        l3:'Indirect Referral Rewards'
    },
    me: {
        inviteLink: 'Invite link',
        upline: 'Upline',
        inviteCount: 'Invites',
        teamCount: 'Team size',
        bigArea: 'Major area (T)',
        smallArea: 'Minor burn (T)',
        team: 'Team members',
        direct: 'Direct',
        indirect: 'Indirect',
        umbrella: 'Umbrella',
        burnT: 'Burn (T)',
        personT: 'Personal (T)',
        teamBurn: 'Team burn (T)',
        teamHash: 'Team hashrate (T)',
        remark: 'Note',
        setRemark: 'Set note',
        remarkPlaceholder: 'Enter a note',
        confirm: 'Confirm',
    },
    notice: {
        title: 'Announcement',
        headline: 'Headline headline headline headline',
        date: '2024-12-22',
        body: 'Dear user,\n\nXXX App will go live at 20:00 on 26 Nov 2024. The minimum subscription base will be updated accordingly. Please refer to the App for the final figure.\n\nThe iOS version is still in review, so Android will launch first.',
    },
};
